<!-- Testimonials Section -->
<section class="testimonials-section">
  <div class="section-container">
    <div class="section-header">
      <div class="header-badge">
        <span class="badge-icon">💬</span>
        <span class="badge-text">Testimonials</span>
      </div>
      <h2 class="section-title">Student & Parent Success Stories</h2>
      <p class="section-subtitle">
        Hear from our students and parents about their transformative learning experience at Tenjah School
      </p>
    </div>
    <div class="testimonials-carousel">
      <div class="carousel-container"
           (mouseenter)="pauseAutoplay()"
           (mouseleave)="resumeAutoplay()">

        <!-- Modern Multi-Card Track -->
        <div class="testimonials-track"
             [style.transform]="'translateX(' + getTransform() + 'px)'">

          <!-- Duplicate testimonials for endless effect -->
          <div class="testimonial-slide"
               *ngFor="let testimonial of getExtendedTestimonials(); let i = index">
            <div class="testimonial-card modern-card"
                 [style.transform]="getCardTransform(i)">

              <!-- Author Info at Top -->
              <div class="testimonial-author">
                <div class="author-avatar">
                  <div class="avatar-circle" [class]="getAvatarColor(i)">
                    <span class="avatar-initials">{{ getInitials(testimonial.name) }}</span>
                  </div>
                </div>
                <div class="author-details">
                  <div class="author-name">{{ testimonial.name }}</div>
                  <div class="author-role">{{ testimonial.role }}</div>
                  <div class="author-subject">{{ testimonial.subject }}</div>
                </div>
              </div>

              <!-- Testimonial Content -->
              <div class="testimonial-content">
                <div class="quote-icon-mini">
                  <svg width="24" height="18" viewBox="0 0 24 18" fill="none">
                    <path d="M10.8 18C10.8 16.1333 11.3667 14.4667 12.5 13C13.6333 11.5333 15.1667 10.5333 17.1 10L18 8C14.9333 8.26667 12.4 9.6 10.4 12C8.46667 14.3333 7.5 17.0667 7.5 20.2V24H10.8V18ZM0 18C0 16.1333 0.566667 14.4667 1.7 13C2.83333 11.5333 4.36667 10.5333 6.3 10L7.2 8C4.13333 8.26667 1.6 9.6 -0.4 12C-2.33333 14.3333 -3.3 17.0667 -3.3 20.2V24H10.8V18ZM0 18Z"
                          fill="currentColor" opacity="0.3"/>
                  </svg>
                </div>
                <p class="testimonial-text">{{ testimonial.content }}</p>
              </div>

              <!-- Card Background Effects -->
              <div class="card-shimmer"></div>
              <div class="card-glow"></div>
            </div>
          </div>
        </div>

        <!-- Minimal Modern Controls -->
        <div class="carousel-navigation">
          <button class="nav-btn prev-btn"
                  (click)="prevTestimonial()"
                  [disabled]="isTransitioning">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>

          <div class="progress-dots">
            <div class="progress-dot"
                 *ngFor="let testimonial of testimonials; let i = index"
                 [class.active]="getCurrentDotIndex() === i"
                 (click)="goToTestimonial(i)">
            </div>
          </div>

          <button class="nav-btn next-btn"
                  (click)="nextTestimonial()"
                  [disabled]="isTransitioning">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Auto-play indicator -->
      <div class="autoplay-indicator" [class.paused]="isAutoplayPaused">
        <div class="progress-bar" [style.animation-duration]="autoplayDuration + 'ms'"></div>
      </div>
    </div>
  </div>
</section>